import { differenceInMinutes } from 'date-fns';

import { WorkLog } from 'domain/entities/Worklog';

export const WORK_LOG_TTL_MINUTES = 4 * 60;

export const isWorkLogExceedTTL = (log: WorkLog) => {
  return log?.endedAt ? differenceInMinutes(new Date(), log.endedAt) > WORK_LOG_TTL_MINUTES : false;
};
